import { render, staticRenderFns } from "./addVote.vue?vue&type=template&id=00cefc6e&scoped=true&"
import script from "./addVote.vue?vue&type=script&lang=js&"
export * from "./addVote.vue?vue&type=script&lang=js&"
import style0 from "./addVote.vue?vue&type=style&index=0&id=00cefc6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cefc6e",
  null
  
)

export default component.exports